exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ChatList__chatList___2G6TI {\n  display: flex;\n  flex-direction: column; }\n", ""]);

// exports
exports.locals = {
	"chatList": "ChatList__chatList___2G6TI"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/containers/ChatList/ChatList.scss
// module id = 700
// module chunks = 0